import api from '../../api/leadRealAPI'
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    properties: { data: [] },
    planStatus: null,
    reachedLimit: null,
    allUnpublished: null
  },

  getters: {
    properties: state => state.properties,
    planStatus: state => state.planStatus,
    reachedLimit: state => state.reachedLimit,
    allUnpublished: state => state.allUnpublished
  },

  mutations: {
    setProperties (state, properties) {
      state.properties = properties
      state.planStatus = properties.plan_status
      state.reachedLimit = properties.reached_limit
    },
    setReachedLimit (state, properties) {
      state.reachedLimit = properties.reached_limit
      state.allUnpublished = properties.all_unpublished
    }
  },

  actions: {
    getProperties ({ commit }) {
      api
        .get('/member/properties')
        .then(response => {
          commit('setProperties', response.data)
        })
        .catch(() => {})
    },
    getReachedLimit ({ commit }, { id }) {
      api
        .get('/member/properties/reached_limit/' + id)
        .then(response => {
          commit('setReachedLimit', response.data)
        })
    }
  }
}
